"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = Title;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const antd_1 = require("antd");
const { Title: AntTitle } = antd_1.Typography;
const StyledTitle = (0, styled_components_1.default)(AntTitle) `
	text-align: ${({ align }) => align};
`;
function Title({ align = 'center', ...rest }) {
    return (0, jsx_runtime_1.jsx)(StyledTitle, { ...rest, align: align });
}
